import * as TabsRootDataAttributes from "./TabsRootDataAttributes.mjs";
export const tabsStateAttributesMapping = {
  tabActivationDirection: dir => ({
    [TabsRootDataAttributes.activationDirection]: dir
  })
};